import { render, staticRenderFns } from "./configureCurriculumKit2Amount.vue?vue&type=template&id=03e6aff3"
import script from "./configureCurriculumKit2Amount.vue?vue&type=script&lang=js"
export * from "./configureCurriculumKit2Amount.vue?vue&type=script&lang=js"
import style0 from "./configureCurriculumKit2Amount.vue?vue&type=style&index=0&id=03e6aff3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports